/** URL paths for the trilingual technology salary guide (no trailing slash). */
export const TECHNOLOGY_SALARY_GUIDE_URL_PATHS = {
  en: '/en/resources/technology-salary-guide-finland-2026-03',
  fi: '/fi/tyoelama/teknologia-alan-palkkaopas-suomi-maaliskuu-2026',
  sv: '/sv/arbetsliv/teknikloner-finland-mars-2026',
} as const;

export type TechnologySalaryGuideLocale = keyof typeof TECHNOLOGY_SALARY_GUIDE_URL_PATHS;
